import CampaignResult from '../models/CampaignResult';

class CampaignsClient {
  http = null;

  endpointPrefix = 'v2/awards/campaign';

  /**
   *
   * @param httpClient{AxiosInstance}
   */
  constructor(httpClient) {
    this.http = httpClient;
  }

  async fetchCampaignResults(sfvs) {
    // const url = `${this.endpointPrefix}/${campaignSfvId}/results`;
    const url = `${this.endpointPrefix}/results`;
    const postData = {
      setFieldValueIds: sfvs,
    };
    const { data } = await this.http.post(url, postData);
    const campaignResults = CampaignResult.fromObject(data);
    return campaignResults;
  }
}

export default CampaignsClient;
